if (!customElements.get('expandable-text')) {
  customElements.define(
    'expandable-text',
    class ExpandableText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-expandable-text-content]');
        this.toggle = this.querySelector('[data-expandable-text-toggle]');

        if (!this.content || !this.toggle || this.initialized) return;

        this.initialized = true;
        this.toggle.addEventListener('click', this.onToggleClick.bind(this));

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.checkOverflow.bind(this));
          this.resizeObserver.observe(this.content);
        } else {
          this.checkOverflow();
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      get expanded() {
        return this.classList.contains('is-expanded');
      }

      onToggleClick() {
        const expanded = !this.expanded;

        this.classList.toggle('is-expanded', expanded);
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (!expanded) this.checkOverflow();
      }

      checkOverflow() {
        if (this.expanded || this.content.clientHeight === 0) return;

        const overflows = this.content.scrollHeight - this.content.clientHeight > 1;
        this.classList.toggle('is-clampable', overflows);
      }
    }
  );
}
